import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Typography } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./Rules";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../../store/app";
import "../../Style/userProfile.less";
import { assignErrorToInput } from "../../../../../store/api";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { ProfileChangePasswordBreadcrumb } from "../../../../../config/BreadcrumbConfig";
import { changePassword, setUserToken, setUserDetail, setInitialData } from "../../../../../store/AuthSlice";
import { useNavigate } from "react-router-dom";
import { CheckCircleOutlined } from "@ant-design/icons";
import { setResetInputAnimation } from "../../../../../config/Global";
const { Text } = Typography;
/**
 * Renders the component for changing password of the user.
 *
 * @return {JSX.Element} The rendered component.
 */
const ProfileChangePassword = () => {
	const [form] = Form.useForm();
	const dispatch: AppDispatch = useDispatch();
	const navigate = useNavigate()
	const [passwordIsChanged, setPasswordIsChanged] = useState(false);

	/**
	 * Updates the user password in the profile with the given data. If an error occurs during the update,
	 * the error status is assigned to the input form.
	 *
	 * @param {any} data - The data to update the user's profile with.
	 * @return {Promise<void>} A promise that resolves when the update is complete.
	 */
	const userProfileUpdate = (data: any) => {
		dispatch(changePassword(data)).then((response: any) => {
			form.resetFields();
			setPasswordIsChanged(true);
			setTimeout(() => {
				setPasswordIsChanged(false);
				dispatch(setUserToken(null));
				dispatch(setUserDetail(null));
				dispatch(setInitialData(null));
				localStorage.removeItem("token");
				localStorage.removeItem("timeIn");
				localStorage.removeItem("timeOut");
				navigate('/login')

			}, 3000);
		}).catch((error: any) =>
			assignErrorToInput(form, error?.STATUS)
		);
	};

	useEffect(() => {
		setResetInputAnimation();
		return () => {
			setResetInputAnimation(false);
		};
	}, [])


	return (
		<div >
			<FormBox
				layout="vertical"
				autoComplete="off"
				form={form}
				id="userProfileUpdate"
				onFinish={userProfileUpdate}
				className="userProfile commanDrawer"
			>
				<Row gutter={[0, 24]}>
					<Col sm={12} xs={24} md={12} xl={8} xxl={8}>
						<InputBox.Password
							name="old_password"
							// label="Old Password"
							label={<>Enter current password <em>*</em></>}
							placeholder=''
							className="ecn-input profile-input"
							// placeholder="Old Password"
							rules={rules.password()}
						/>
					</Col>
					<Col sm={12} xs={24} md={12} xl={8} xxl={8}>
						<InputBox.Password
							name="new_password"
							// label="New Password"
							label={<>Enter new password <em>*</em></>}
							placeholder=''
							className="ecn-input profile-input"
							// placeholder="New Password"
							rules={rules.password()}
						/>
					</Col>
					<Col sm={12} xs={24} md={12} xl={8} xxl={8}>
						<InputBox.Password
							name="confirm_password"
							// label="Confirm Password"
							// placeholder="Confirm Password"
							label={<>Confirm new password <em>*</em></>}
							placeholder=''
							dependencies={['new_password']} // This ensures re-validation when 'password' changes

							className="ecn-input profile-input"
							rules={rules.password_confirmation()}
						/>
					</Col>
				</Row>
				{passwordIsChanged && <Text strong style={{ color: "#1dab3b" }}><CheckCircleOutlined style={{ marginRight: '5px' }} />Password changed successfuly</Text>}

				<div className="profile-btn-row">
					<Button className="profile-save-btn" htmlType="submit">Change password</Button>
				</div>
			</FormBox>


		</div>
	);
};

export default ProfileChangePassword;
